import { onApplicationMenu, onTopLevelRoutes } from 'core';
import Router from './components/Router';

onTopLevelRoutes(() => ({
  path: '/subscription',
  secure: true,
  component: Router,
}));

onApplicationMenu(() => ({
  group: 'business',
  label: 'subscriptions',
  icon: 'sync alternate',
  to: '/subscription',
}));
